import { Matrix } from "ml-matrix";

import kitti0000000000ImageA from "../../../assets/twoview/2011_09_26_drive_0001_sync/2011_09_26/2011_09_26_drive_0001_sync/image_02/data/0000000000.png";
import kitti0000000000ImageB from "../../../assets/twoview/2011_09_26_drive_0001_sync/2011_09_26/2011_09_26_drive_0001_sync/image_03/data/0000000000.png";

export const KITTI_SCENES = [
  {
    id: "kitti_2011_09_26_0000000000",
    name: "KITTI — Urban Road",
    imageA: kitti0000000000ImageA,
    imageB: kitti0000000000ImageB,
  },
];

export async function loadKITTIScene(sceneId) {
  const scene = KITTI_SCENES.find((candidate) => candidate.id === sceneId);

  if (!scene) {
    throw new Error(`Unknown KITTI scene: ${sceneId}`);
  }

  // Rectified color-camera intrinsics from KITTI calib_cam_to_cam.txt.
  const cameraMatrixA = new Matrix([
    [721.5377, 0, 609.5593],
    [0, 721.5377, 172.854],
    [0, 0, 1],
  ]);

  const cameraMatrixB = new Matrix([
    [721.5377, 0, 609.5593],
    [0, 721.5377, 172.854],
    [0, 0, 1],
  ]);

  const calibration = {
    cameraMatrixA,
    cameraMatrixB,

    // Rectified color-camera baseline in meters.
    baseline: 0.5327,

    width: 1242,
    height: 375,

    // Rectified stereo uses horizontal disparity directly.
    disparityOffset: 0,

    // Maximum disparity search bound for the dense matcher.
    disparityCount: 256,
  };

  return {
    ...scene,
    calibration,
  };
}
